exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_option_3aYvv0kcbElUpLXgJbV1V {\n  width: 100%;\n  height: 30px;\n}\n\n.IA_icon_3rXScvLmp3y5-DMtTrIbth {\n  float: left;\n}\n\n.IA_label_3ND93eoyY1jJG3WGLjqllb {\n  float: left;\n  margin-left: 10px;\n  line-height: 30px;\n}", ""]);

// Exports
exports.locals = {
	"IA_option": "IA_option_3aYvv0kcbElUpLXgJbV1V",
	"IA_icon": "IA_icon_3rXScvLmp3y5-DMtTrIbth",
	"IA_label": "IA_label_3ND93eoyY1jJG3WGLjqllb"
};